import { useState, useRef } from 'react';
import cx from 'classnames';
import useMediaQuery from '@mui/material/useMediaQuery';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Fade from '@mui/material/Fade';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Popper from '@mui/material/Popper';
import { getPathName, ROUTES } from '@openclassrooms/routing';
import browser from '@openclassrooms/utils/browser';
import { translate } from '@openclassrooms/translations';
import { useTheme, alpha } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';
import { styled } from '@classify/react-core-components/styles';
import MainHeaderMenu from '../MainHeaderMenu';
import MemberAvatar from './MemberAvatar';
import MainHeaderVisitorMenu from './MainHeaderVisitorMenu';
import VisitorAvatar from './VisitorAvatar';
const mainHeaderMenuId = 'main-header-menu';
const RootIconButton = styled(IconButton)(({
  theme: {
    spacing,
    palette,
    transitions
  }
}) => ({
  border: `1px solid ${palette.layout.line.divider}`,
  borderRadius: 50,
  padding: spacing(0.5),
  '&:hover,&:focus': {
    backgroundColor: alpha(palette.brand.main, 0.16)
  },
  '& .actionsAvatar__buttonIcon': {
    color: palette.text.onMain,
    marginLeft: spacing(1),
    marginRight: spacing(0.5),
    transition: `transform ${transitions.duration.shortest}ms ${transitions.easing.easeInOut}`
  },
  '& .actionsAvatar__buttonExpanded': {
    transform: 'rotate(180deg)'
  },
  '& .actionsAvatar__wrapper': {
    paddingBottom: spacing(3),
    marginBottom: spacing(-3),
    marginLeft: spacing(1),
    '.jobSurvey &': {
      display: 'none'
    },
    '& .actionsAvatar__badge': {
      backgroundColor: palette.primary.main,
      top: 7,
      right: 7,
      border: `1px solid ${palette.text.onContrasted}`
    }
  }
}));
const MainHeaderActions = ({
  user = {},
  right = {},
  counters,
  onLogOut = () => {}
}) => {
  const anchorRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useState(false);
  const {
    breakpoints
  } = useTheme();
  const shouldHaveAvatarMenuFullWidth = useMediaQuery(breakpoints.down('sm'));
  const shouldRenderTinyAvatar = useMediaQuery(breakpoints.down('md'));
  const toggleMenuTimeout = useMediaQuery(breakpoints.down('lg')) ? 400 : 0;
  const profileAvatar = user ? <MemberAvatar user={user} isSmaller={shouldRenderTinyAvatar} /> : <VisitorAvatar isSmaller={shouldRenderTinyAvatar} />;
  const countersTotal = counters.notificationCount + counters.moderationNotificationCount;
  const profileAvatarWithBadge = countersTotal > 0 ? <Badge classes={{
    colorPrimary: 'actionsAvatar__badge'
  }} color="primary" badgeContent={countersTotal}>
        {profileAvatar}
      </Badge> : profileAvatar;
  const buttonProfileAvatar = <RootIconButton data-event={user ? undefined : 'Button|Clicked|header-signin'} disableFocusRipple aria-owns={isMenuOpen ? mainHeaderMenuId : null} aria-haspopup aria-expanded={isMenuOpen} title="Menu" onClick={() => {
    toggleMenu(!isMenuOpen);
    browser.document.activeElement.blur();
    setTimeout(() => browser.document.getElementById(mainHeaderMenuId).focus(), 50);
  }} data-testid="mainHeaderAvatar" aria-label={translate('global.word.menu')}>
      <div>{profileAvatarWithBadge}</div>
      <ExpandMore className={cx('actionsAvatar__buttonIcon', {
      actionsAvatar__buttonExpanded: isMenuOpen
    })} />
    </RootIconButton>;
  const popperSx = {
    zIndex: 'appBar'
  };
  return <>
      <ClickAwayListener onClickAway={() => {
      setTimeout(() => toggleMenu(false), toggleMenuTimeout);
    }}>
        <Box ref={anchorRef} sx={{
        marginLeft: 2
      }}>
          {buttonProfileAvatar}
        </Box>
      </ClickAwayListener>

      <Popper open={isMenuOpen} anchorEl={anchorRef.current} placement="bottom-end" transition {...shouldHaveAvatarMenuFullWidth ? {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [16, 0]
        }
      }],
      sx: {
        ...popperSx,
        width: '100%'
      }
    } : {
      sx: popperSx
    }}>
        {({
        TransitionProps
      }) => <Fade {...TransitionProps} timeout={150}>
            <div>
              {user ? <MainHeaderMenu id={mainHeaderMenuId} moderationNotificationCount={counters.moderationNotificationCount} notificationCount={counters.notificationCount} displayableName={user.displayName} profileAvatar={profileAvatar} canSeeMentorDashboard={right.canSeeMentorDashboard} canSeeOrganizationDashboard={right.canSeeOrganizationDashboard} canSeeAdminDashboard={right.canSeeAdminDashboard} canSeeTutorDashboard={right.canSeeTutorDashboard} canDisplayForumAlert={right.canDisplayForumAlert} profileLink={getPathName(ROUTES.ACCOUNT.INDEX)} profileCompletionRate={user.profileCompletionRate} organizationName={user.organizationName} canEditCourse={right.canEditCourse} employerSpaceLink={user.link?.employerSpace} onLogOut={onLogOut} /> : <MainHeaderVisitorMenu />}
            </div>
          </Fade>}
      </Popper>
    </>;
};
export default MainHeaderActions;